import { useTranslation } from 'react-i18next';

import { Button, TButton } from '@/shared/ui/lib/Button';
import { SvgIcon } from '@/shared/ui/SvgIcon';

interface ICreateChannelButtonProps extends TButton {}

export const CreateChannelButton = ({
  onClick,
  ...otherProps
}: ICreateChannelButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="contained"
      onClick={onClick}
      startIcon={<SvgIcon name="add" />}
      size="large"
      {...otherProps}
    >
      {t('channels:buttons.addChannel')}
    </Button>
  );
};
